module.exports = __webpack_public_path__ + "img/hero-main-2-eng.1ae23af7.png";